<template>
    <div class="nav-bar">
        <div class="nav-row" >
            <router-link v-for="(tab, index) in tabs" :key="index" :to="tab.link">
                <div class="nav-item">{{ tab.name }}</div>
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
import {VueClassTemplate} from "@/util/VueClassTemplate";
import {Component, Prop} from "vue-property-decorator";
@Component({})
export default class BubbleTabs extends VueClassTemplate{
    @Prop({type: Array, required: true}) tabs!: Array<{name: string; link: string}>;
}
</script>

<style scoped lang="scss">
.nav-bar{
    margin-bottom: 16px;
    .nav-row{
        min-height: 36px;
        .nav-item:hover{
            background: rgba(0,0,0,.2);
        }
        .router-link-exact-active{
            div{
                background: rgba(0,0,0,.5);
                pointer-events: none;
            }
        }
        .nav-item[active]{
            router-link{
                pointer-events: none;
            }
        }
        .nav-item{
            background: rgba(0,0,0,.1);
            border-radius: 5px;
            padding: 5px 12px;
            display: inline-block;
            margin-right: 10px;
            margin-bottom: 4px;
            color: white;
            *{
                color: white;
            }
        }
    }
}
@media only screen and (max-width: $breakPoint - 1px){
    .nav-bar{
        margin-top: 78px;
        margin-bottom: -16px;

        .nav-row{
            padding-left: 8px;
            padding-right: 8px;
            height: auto !important;

            .nav-item:hover{
                background: rgba(253,70,39,1);
            }

            .router-link-exact-active{
                div{
                    background: rgba(253,70,39,1); //rgba(253,70,39,1)
                    pointer-events: none;
                    color: white;
                }
            }
            .nav-item{
                background-blend-mode: screen;
                background: white ; //rgba(125,35,25,1)
                border-color: #E3E3E3 ;
                color: #FA2922 ;
                border-style: solid;
                border-width: 1px;
            }
        }

    }



}

</style>
